/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dark_Slim_Emu_NoteInputs */

const en_dark_slim_emu_note = /** @type {(inputs: Dark_Slim_Emu_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load imports`)
};

const de_dark_slim_emu_note = /** @type {(inputs: Dark_Slim_Emu_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imports konnten nicht geladen werden`)
};

/**
* | output |
* | --- |
* | "Could not load imports" |
*
* @param {Dark_Slim_Emu_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dark_slim_emu_note = /** @type {((inputs?: Dark_Slim_Emu_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dark_Slim_Emu_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dark_slim_emu_note(inputs)
	return de_dark_slim_emu_note(inputs)
});